import {Injectable} from '@angular/core';
import {BehaviorSubjectService, Product} from '@uofu-uss-aux/software-catalog-ng-core';
import {Observable, of} from 'rxjs';
import Fuse from 'fuse.js';
import IFuseOptions = Fuse.IFuseOptions;


@Injectable({
  providedIn: 'root'
})
export class SearchService extends BehaviorSubjectService<boolean> {

  private readonly searchOptions: IFuseOptions<Product>;

  constructor() {
    // by default we are not searching
    super(false);

    const keys: Array<any> = ['title', 'shortDescription', 'longDescription', 'vendor.shortName', 'vendor.fullName'];

    this.searchOptions = {
      isCaseSensitive: false,
      shouldSort: true,
      findAllMatches: true,
      includeScore: false,
      threshold: 0.2,
      location: 0,
      distance: 100,
      minMatchCharLength: 1,
      keys
    };
  }

  search(criteria: string, products: ReadonlyArray<Product>): Observable<ReadonlyArray<Product>> {
    if (!criteria) {
      return of(products);
    } else {
      const fuse = new Fuse<Product>(products, this.searchOptions);
      return of(fuse.search(criteria).map(result => result.item));
    }
  }

  toggleSearch(): boolean {
    return this.value = !this.value;
  }

  enableSearch(): boolean {
    return this.value = true;
  }

  disableSearch(): boolean {
    return this.value = false;
  }
}
